<template>
  <v-card class="elevation-0">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <SelectorCountry
            v-model="countries"
            autoload
            class="mt-4"
            multiple
            label="Location (Countries)"
            :help-text="'You can specify countries that you want to include into your poll results'"
            required
            return-object
            :rules="rules.countries"
            persistent-counter
            :counter="3"
            @update:model-value="onUpdate"
          />
          <SelectorLanguage
            v-model="languages"
            autoload
            multiple
            class="mt-4"
            label="Language(s)"
            :help-text="'You can specify language(s) that you want to include into your poll results'"
            required
            return-object
            :rules="rules.languages"
            persistent-counter
            :counter="3"
            @update:model-value="onUpdate"
          />
          <SelectorAgeCategories
            v-model="ages"
            autoload
            multiple
            class="mt-4"
            label="Age Categories"
            :help-text="'You can specify age categories that you want to include into your poll results'"
            required
            return-object
            :rules="rules.ages"
            persistent-counter
            :counter="3"
            @update:model-value="onUpdate"
          />

          <SelectorGenderCategories
            v-model="genders"
            autoload
            multiple
            class="mt-4"
            label="Gender(s)"
            :help-text="'You can specify gender of your target audience'"
            required
            return-object
            :rules="rules.genders"
            persistent-counter
            :counter="3"
            @update:model-value="onUpdate"
          />
        </v-col>
        <v-col cols="12" md="6">
          <SelectorParentInterestsCategories
            v-model="parentInterests"
            autoload
            multiple
            class="mt-4"
            label="Please Select Parent Categories"
            :help-text="'You can specify a set of sources from where you want to receive answers'"
            required
            :counter="3"
            return-object
            persistent-counter
            :rules="rules.parentInterests"
            @update:model-value="onUpdate"
          />
          <SelectorInterestsCategories
            v-for="parent in parentInterests"
            :key="parent.id"
            v-model="interests"
            :parent-id="parent.id"
            :parent="parent"
            autoload
            multiple
            class="mt-4"
            :label="`Select Category Tags from  ${parent.name}`"
            :help-text="'You can specify a set of sources from where you want to receive answers'"
            required
            :counter="3"
            return-object
            persistent-counter
            :rules="rules.interests"
            @update:model-value="onUpdate"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
    
    
    
    
<script>
import SelectorLanguage from "@/components/atoms/common/autocompletes/SelectorLanguage.vue";
import SelectorAgeCategories from "../../atoms/common/autocompletes/SelectorAgeCategories.vue";
import SelectorCountry from "../../atoms/common/autocompletes/SelectorCountry.vue";
import SelectorGenderCategories from "../../atoms/common/autocompletes/SelectorGenderCategories.vue";
import SelectorInterestsCategories from "../../atoms/common/autocompletes/SelectorInterestsCategories.vue";
import SelectorParentInterestsCategories from "../../atoms/common/autocompletes/SelectorParentInterestsCategories.vue";

export default {
  name: "CampaignAudience",
  components: {
    SelectorAgeCategories,
    SelectorGenderCategories,
    SelectorParentInterestsCategories,
    SelectorInterestsCategories,
    SelectorCountry,
    SelectorLanguage,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["next", "onDetails", "update:modelValue"],
  data() {
    return {
      ages: [],
      genders: [],
      parentInterests: [],
      interests: [],
      countries: [],
      languages: [],

      rules: {
        ages: [
          (v) => !!v || "You must select at least one",
          (v) => v.length <= 3 || "You can select only 3",
        ],
        languages: [
          (v) => !!v || "You must select at least one",
          (v) => v.length <= 3 || "You can select only 3",
        ],
        genders: [
          (v) => !!v || "You must select at least one",
          (v) => v.length <= 3 || "You can select only 3",
        ],
        parentInterests: [
          (v) => !!v || "You must select at least one category",
          (v) => v.length <= 3 || "You can select only 3 categories",
        ],
        interests: [
          (v) => !!v || "You must select at least one category",
          (v) => v.length <= 3 || "You can select only 3 categories",
        ],
        countries: [
          (v) => !!v || "You must select at least one",
          (v) => v.length <= 3 || "You can select only 3",
        ],
      },
    };
  },
  computed: {},

  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.ages = value.ages || [];
        this.genders = value.genders || [];
        this.parentInterests = value.parentInterests || [];
        this.interests = value.interests || [];
        this.countries = value.countries || [];
        this.languages = value.languages || [];
      },
    },
  },
  created() {},
  methods: {
    onUpdate() {
      this.$emit("update:modelValue", {
        ages: this.ages,
        genders: this.genders,
        parentInterests: this.parentInterests,
        interests: this.interests,
        countries: this.countries,
        languages: this.languages,
      });
    },
  },
};
</script>